import React, { useContext, useEffect, useState } from 'react';
import FinanceApprovalPageHeader from '../../../views/pages/manage/unAssigned/studentFinanceApproval/components/ApprovalPageHeader';
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import { useHistory } from "react-router-dom";
import { Card } from 'reactstrap';
import Filters from './Filters';
import { checkPermission, updateRequest, updateRequestLabels } from '../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { exportAndSendCsvToEmail, getConfigs, getDropdowns, getRefundReason, getRefundRequests, updateApprovalRequest, updateApprovalRequests } from './utils';
import ApprovalRequestsList from './ApprovalRequestsList';
import { dummyData } from './constant';
import ApprovalSentSuccessDialog from 'views/pages/manage/unAssigned/examCharges/examChargesDetails/dialogs/ApprovalSentSuccessDialog';
import { getRoleId } from 'modules/studentTransfer/transferApproval/utils';
import { PermissionContext } from 'appContext';
import { processRowList } from 'views/pages/manage/businessArea/component/FirstForm/constant';
import moment from 'moment';
import { getAppliedFilterCount } from 'modules/studentTransfer/components/searchStudent/studentTransfersListing/utils';
import { UserDetails } from 'appContext';
import {failureToast} from "views/pages/manage/common/utils/methods/toasterFunctions/function";
const RefundApproval = ({ userPermissions }) => {
  const [approvalRequests, setApprovalRequests] = useState([]);
  const [dropdownData, setDropdownData] = useState({});
  const [globalFilter, setGlobalFilter] = useState({})
  const history = useHistory();
  const [approvalActionSuccessDialogOpen, setApprovalActionSuccessDialogOpen] = useState(false);
  const [approvalActionSuccessDialogInfo, setApprovalActionSuccessDialogInfo] = useState(false);
  const [refundApprovalConfigs, setRefundApprovalConfigs] = useState({})
  const [roleid, setUserRoleId] = useState()
  const permissions = useContext(PermissionContext);
  const isApproverPermission = checkPermission(userPermissions, "A");
  const [completionRefundReasonList, setCompletionRefundReasonList] = useState([])

  const [loading, setLoading] = useState(false);
  const [paginationInfo, setPaginationInfo] = useState({
    currPageNo: 0,
    currPageSize: 10,
    totalRecords: 0
  })

  const [bulkAction, setBulkAction] = useState('')
  const userDetails = useContext(UserDetails);
  const getApprovalRequests = async ({
    filters = globalFilter,
    pageNo = paginationInfo?.currPageNo,
    pageSize = paginationInfo?.currPageSize,
    dropdowns = dropdownData,
    roleId = roleid,
    approvalConfigs = refundApprovalConfigs,
    completionReasonList = completionRefundReasonList
  }) => {
    try {

      setLoading(true);
      const resp = await getRefundRequests({ pageNo, pageSize, filters, dropdowns });

      if (resp?.code === 200) {

        const { totalRecords, paginatedData, currentPage, totalPage
        } = resp?.data;
        const updatedRequests = updateApprovalRequest(paginatedData, dropdowns, roleId, approvalConfigs, completionReasonList);
        
    setApprovalRequests(updatedRequests);
        setPaginationInfo(prev => ({
          ...prev,
          totalRecords,
          currPageNo: currentPage,
          currPageSize: pageSize,
          totalPage: totalPage

        }))

        setGlobalFilter({
          ...filters,
          appliedFilterCount: getAppliedFilterCount(filters, ['psid', 'applicationId', 'refundNumber'])
        });
      }

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }
 const init = async () => {
  try {
    setLoading(true);
    const [dropdowns, completionReasons] = await Promise.all([
      getDropdowns(),
      getRefundReason('COMPLETION_REFUND'),
    ]);
    const roleId = await getRoleId(permissions?.roleType);
    const approvalConfigs = (await getConfigs({
      ...updateRequestLabels({ businessAreas: dropdowns?.businessAreas }),
      ...updateRequest({ cashiers: dropdowns?.cashierOffice }),
    }))?.data ?? [];

    setDropdownData(dropdowns);
    setUserRoleId(roleId);
    setRefundApprovalConfigs(approvalConfigs);
    setCompletionRefundReasonList(completionReasons);

    // ✅ await this so the loader stays on until data is actually here
    await getApprovalRequests({
      dropdowns,
      approvalConfigs,
      roleId,
      completionReasonList: completionReasons,
    });
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);  // single source of truth, fires after everything is done
  }
};

  useEffect(() => {
    permissions && init();
  }, []);

  const updateStatus = async (reqObj) => {
    try {
      const isSentForCorrection = reqObj?.dialogInfo?.heading === "Send back for correction";
      if(isSentForCorrection && !reqObj?.remark){
       failureToast("Please enter remarks!");
       return;
      }
      const resp = await updateApprovalRequests(reqObj);

      if (resp?.code === 200) {
        const actionDispValue =
          reqObj?.approvalAction === "APPROVE"
            ? "Approved"
            : reqObj?.approvalAction === "REJECT"
              ? "Rejected"
              : "Sent for correction";

        const refundNumber = reqObj?.refundNumber;
        const date = moment().format("DD/MM/YYYY");
        const time = moment().format("hh:mm A");

        setApprovalActionSuccessDialogInfo({
          heading: `Refund request no. ${refundNumber} has been ${actionDispValue.toLowerCase()}.`,
          subHeading: `${actionDispValue} on ${date} at ${time}.`,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const isDateRangeValid = (fromDate, toDate) => {
  const startDate = moment(fromDate);
  const endDate = moment(toDate);
  const diffDays = endDate.diff(startDate, "days");
  return diffDays <= 60;
};

  const downloadHandler = async (filters, userDetails, dropdowns) => {
    try {
      setLoading(true);
      if(!filters?.refundRequestDateFrom || !filters?.refundRequestDateTo){
        failureToast("Please select and apply date range filter to download the report");
        return;
      }
    if (!isDateRangeValid(filters?.refundRequestDateFrom, filters?.refundRequestDateTo)) {
        failureToast("Selected date range cannot be more than 60 days");
        return;
}
      await exportAndSendCsvToEmail(filters, userDetails, dropdowns);
    }
    catch (err) {
      console.error(err)
    }
    finally {
      setLoading(false);
    }
  }
  // In each of those components
const rc = React.useRef(0);
rc.current++;
console.log(`[FinanceApprovalPageHeader] render #${rc.current} at ${performance.now().toFixed(0)}ms`);

  return (
    <div>
      <FinanceApprovalPageHeader
        heading="Student refund approvals"
        subHeading="Here you can approve or reject the refund requests of students"
      />
      <Card className="m-3 px-2 pt-3">
        <div className="d-flex justify-content-between">
          <div>
            <BackArrow
              className="mr-2 cursor"
              onClick={() => history.goBack()}
            />
            <h3 className="d-inline">Student refund approvals</h3>
          </div>

          <Filters
            dropdowns={dropdownData}
            getApprovalRequests={getApprovalRequests}
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
            downloadHandler={downloadHandler}
            userDetails={userDetails}
          />

        </div>
        <hr className="my-2" />
        <ApprovalRequestsList
          approvalRequests={approvalRequests}
          updateStatus={updateStatus}
          bulkAction={bulkAction}
          setBulkAction={setBulkAction}
          loading={loading}
          isApprovePermission={isApproverPermission}
          paginationInfo={paginationInfo}
          getApprovalRequests={getApprovalRequests}
          setGlobalFilter={setGlobalFilter}
          globalFilter={globalFilter}
          dropdowns={dropdownData}
          setLoader={setLoading}
          userPermissions={userPermissions}
        />
      </Card>
      <ApprovalSentSuccessDialog
        open={approvalActionSuccessDialogInfo}
        setOpen={setApprovalActionSuccessDialogInfo}
        heading={approvalActionSuccessDialogInfo?.heading}
        subHeading={approvalActionSuccessDialogInfo?.subHeading}
        closeCb={() => getApprovalRequests({})}

      />
    </div>
  )
}

export default RefundApproval